/** Rejection for provider work that finished after logout or a roaster change, so callers can skip stale success/error UI. */
export class SessionEndedError extends Error {
  constructor() {
    super("Session ended before the request completed");
    this.name = "SessionEndedError";
  }
}
